'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/template-stockists');

(0, _themeSections.load)(['template-stockists']);